import FolderApi from '@/api/folder'
import router from '@/router'
import cookie from '@/services/cookie'

const setFoldersAction = ({ commit }, payload) => {
  commit('setFolders', payload)
}
const getFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.getFolders(params)
  if (folders && folders.length > 0) {
    cookie.setValue('hasFolder', true)
  }
  if (router.currentRoute.name === 'SharedWithMe') return
  commit('setFolders', folders)
  commit('setCurrentFolderDepth', null)
  commit('setBreadcrumbsMultipleLevelsArray', [])
  commit('setCurrentFolder', null)
}

const getShareFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.getShareFolders(params)
  commit('setFolders', folders)
  commit('setCurrentFolderDepth', null)
  commit('setBreadcrumbsMultipleLevelsArray', [])
  commit('setCurrentFolder', null)
}

const getTeamFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.getTeamFolders(params)
  if (router.currentRoute.name !== 'Team') return
  commit('setFolders', folders)
  commit('setCurrentFolder', null)
}

// sub-folders
const getSubFoldersAction = async ({ commit }, params) => {
  const { parentFolderId } = params
  const {
    folders,
    breadcrumbs,
    depth,
    hasShared,
    userId,
    ownerId,
  } = await FolderApi.getSubFolders(parentFolderId, params)
  if (router.currentRoute.name === 'SharedWithMe') return
  commit('setFolders', folders)
  commit('setBreadcrumbsMultipleLevelsArray', breadcrumbs)
  commit('setCurrentFolderDepth', depth)
  commit('setParentFolderHasShared', hasShared)
  commit('setCurrentFolder', {
    userId,
    ownerId,
  })
}
const getShareSubFoldersAction = async ({ commit }, params) => {
  const { parentFolderId } = params
  const {
    folders, breadcrumbs, depth, permissions, userId, ownerId,
  } = await FolderApi.getShareSubFolders(parentFolderId, params)
  commit('setFolders', folders)
  commit('setBreadcrumbsMultipleLevelsArray', breadcrumbs)
  commit('setCurrentFolderDepth', depth)
  commit('setCurrentFolderPermission', permissions)
  commit('setCurrentFolder', {
    userId,
    ownerId,
  })
}

export default {
  setFoldersAction,
  getFoldersAction,
  getTeamFoldersAction,

  // sub-folders
  getSubFoldersAction,
  getShareFoldersAction,
  getShareSubFoldersAction,
}
